/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategySavedView = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategySavedView model module.
   * @module model/StrategySavedView
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategySavedView</code>.
   * @alias module:model/StrategySavedView
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>StrategySavedView</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategySavedView} obj Optional instance to populate.
   * @return {module:model/StrategySavedView} The populated <code>StrategySavedView</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('FilterJson')) {
        obj['FilterJson'] = ApiClient.convertToType(data['FilterJson'], 'String');
      }
      if (data.hasOwnProperty('ContentSettingsJson')) {
        obj['ContentSettingsJson'] = ApiClient.convertToType(data['ContentSettingsJson'], 'String');
      }
      if (data.hasOwnProperty('MapFilterJson')) {
        obj['MapFilterJson'] = ApiClient.convertToType(data['MapFilterJson'], 'String');
      }
      if (data.hasOwnProperty('OrganizationStructureFilterJson')) {
        obj['OrganizationStructureFilterJson'] = ApiClient.convertToType(data['OrganizationStructureFilterJson'], 'String');
      }
      if (data.hasOwnProperty('IsPublic')) {
        obj['IsPublic'] = ApiClient.convertToType(data['IsPublic'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} FilterJson
   * @default ''
   */
  exports.prototype['FilterJson'] = '';
  /**
   * @member {String} ContentSettingsJson
   * @default ''
   */
  exports.prototype['ContentSettingsJson'] = '';
  /**
   * @member {String} MapFilterJson
   * @default ''
   */
  exports.prototype['MapFilterJson'] = '';
  /**
   * @member {String} OrganizationStructureFilterJson
   * @default ''
   */
  exports.prototype['OrganizationStructureFilterJson'] = '';
  /**
   * @member {Boolean} IsPublic
   * @default false
   */
  exports.prototype['IsPublic'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


